import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.0012 3.00626V9.99917"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99874 4.77699V19.0029"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0037 10.9996V5.61034C21.0037 5.17916 20.7286 4.797 20.3195 4.66094L15.6335 3.09929C15.2233 2.96224 14.7792 2.96224 14.368 3.09829L9.63101 4.67695C9.21984 4.81401 8.77665 4.81401 8.36548 4.67695L4.31279 3.32639C3.66553 3.1103 2.99625 3.5925 2.99625 4.27578V15.6195C2.99625 15.9987 3.21034 16.3448 3.54948 16.5149L8.10437 18.7918C8.66761 19.0739 9.33088 19.0739 9.89412 18.7918L12 17.7384"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0042 20.0033L20.1404 18.1396"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0025 13.0004C19.6602 13.0004 21.0038 14.344 21.0038 16.0017C21.0038 17.6594 19.6602 19.0029 18.0025 19.0029C16.3448 19.0029 15.0013 17.6594 15.0013 16.0017C15.0013 14.344 16.3448 13.0004 18.0025 13.0004"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
